import {StoreState} from "../../app/models/states/AppStates";
import {connect} from "react-redux";
import {MesseApp} from "./MesseApp";

const mapStateToProps = (state: StoreState) =>
{
    return {
        mainState: state.appState.mainState,
        lastMainState: state.appState.lastMainState,
    };
};

const mapDispatchToProps = (dispatch) =>
{
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MesseApp);